import { jsx as a, jsxs as d } from "react/jsx-runtime";
import { tv as w } from "../tailwind-variants.config.js";
import { ButtonIcon as g } from "./ButtonIcon.js";
import { ButtonLoader as v } from "./ButtonLoader.js";
import { Tooltip as f } from "../Tooltip/index.js";
const x = w({
  base: "jm-h-fit jm-flex jm-items-center jm-border-none jm-transition jm-cursor-pointer jm-font-label jm-rounded-lg disabled:jm-cursor-default focus-visible:jm-outline-jutro-new-blue-500 focus-visible:jm-outline focus-visible:jm-outline-4",
  variants: {
    variant: {
      primary: "jm-text-white jm-bg-jutro-new-blue-800 hover:jm-bg-jutro-new-blue-900 active:jm-bg-jutro-new-blue-950 disabled:jm-bg-jutro-new-warm-gray-300",
      secondary: "jm-text-jutro-new-blue-800 jm-bg-jutro-new-blue-100 hover:jm-bg-jutro-new-blue-300 hover:jm-text-jutro-new-blue-950 active:jm-bg-jutro-new-blue-400 active:jm-text-jutro-new-blue-950 disabled:jm-bg-jutro-new-warm-gray-300 disabled:jm-text-white",
      negative: "jm-text-white jm-bg-jutro-new-rose-800 hover:jm-bg-jutro-new-rose-900 active:jm-bg-jutro-new-rose-950 disabled:jm-bg-jutro-new-warm-gray-300",
      ghost: "jm-text-jutro-new-blue-800 jm-bg-transparent hover:jm-bg-jutro-new-blue-50 hover:jm-text-jutro-new-blue-950 active:jm-bg-jutro-new-blue-300 active:jm-text-jutro-new-blue-950 disabled:jm-text-jutro-new-warm-gray-400 disabled:jm-bg-transparent",
      negativeGhost: "jm-text-jutro-new-rose-800 jm-bg-transparent hover:jm-bg-jutro-new-rose-100 hover:jm-text-jutro-new-rose-950 active:jm-bg-jutro-new-rose-200 active:jm-text-jutro-new-rose-950 disabled:jm-text-jutro-new-warm-gray-400 disabled:jm-bg-transparent",
      secondaryNegative: "jm-text-jutro-new-rose-900 jm-bg-jutro-new-rose-100 hover:jm-bg-jutro-new-rose-200 hover:jm-text-jutro-new-rose-950 active:jm-bg-jutro-new-rose-300 active:jm-text-jutro-new-rose-950 disabled:jm-text-white disabled:jm-bg-jutro-new-warm-gray-300"
    },
    size: {
      condensed: "jm-gap-1 jm-py-0 jm-px-2",
      regular: "jm-gap-2 jm-py-2.5 jm-px-4",
      large: "jm-gap-2 jm-py-4 jm-px-6"
    },
    full: {
      true: "jm-w-full",
      false: "jm-w-fit"
    },
    onlyIcon: {
      true: "jm-aspect-square jm-p-0"
    },
    loading: {
      true: "jm-text-transparent disabled:jm-text-transparent jm-relative jm-pointer-events-none jm-select-none"
    },
    iconPosition: {
      left: "jm-flex-row",
      right: "jm-flex-row-reverse"
    },
    justify: {
      start: "jm-justify-start jm-text-start",
      center: "jm-justify-center jm-text-center",
      between: "jm-justify-between jm-text-start"
    }
  },
  compoundVariants: [
    {
      variant: "ghost",
      loading: !0,
      class: "jm-bg-jutro-new-blue-300"
    },
    {
      variant: "negativeGhost",
      loading: !0,
      class: "jm-bg-jutro-new-rose-200"
    },
    {
      variant: "secondaryNegative",
      loading: !0,
      class: "jm-bg-jutro-new-rose-200"
    },
    {
      justify: ["start", "between"],
      loading: !0,
      class: "jm-justify-center"
    },
    {
      onlyIcon: !0,
      size: "condensed",
      class: "jm-p-1"
    },
    {
      onlyIcon: !0,
      size: "regular",
      class: "jm-p-2.5"
    },
    {
      onlyIcon: !0,
      size: "large",
      class: "jm-p-4"
    }
  ],
  defaultVariants: {
    size: "regular",
    variant: "primary",
    iconPosition: "left",
    full: !0,
    justify: "center"
  }
}), k = ({
  size: r,
  variant: j,
  loading: n,
  iconPosition: i,
  full: s,
  justify: o = "center",
  ...e
}) => {
  const t = "text" in e, l = "icon" in e, u = "tooltipPosition" in e, b = x({
    size: r,
    variant: j,
    onlyIcon: !t,
    loading: n,
    iconPosition: i,
    full: s,
    justify: o
  }), m = l ? e.icon : void 0, c = t ? e.text : void 0;
  return !t && typeof e.withTooltip > "u" && (e.withTooltip = !0), (r !== "large" || j !== "secondary" || s !== !0) && o !== "center" ? "Invalid <Button /> params: only large & secondary & full buttons can use justify param (change from default center)" : o === "start" && i === "right" ? "Invalid <Button /> params: justify=start works only with iconPosition=left" : o === "between" && i === "left" ? "Invalid <Button /> params: justify=between works only with iconPosition=right" : /* @__PURE__ */ a(
    f,
    {
      position: u ? e.tooltipPosition : void 0,
      disabled: t || e.disabled || !u,
      trigger: /* @__PURE__ */ d(
        "button",
        {
          ...e,
          id: e.id,
          type: e.type,
          onClick: e.onClick,
          disabled: e.disabled,
          "aria-label": t ? void 0 : e.label,
          tabIndex: n ? -1 : e.tabIndex,
          autoFocus: !1,
          className: b,
          children: [
            n && /* @__PURE__ */ a(
              v,
              {
                variant: j,
                size: r,
                disabled: e.disabled
              }
            ),
            n && m && // placeholder to widen the container in place of the hidden icon
            /* @__PURE__ */ a("div", { className: r === "condensed" ? "jm-w-4" : "jm-w-6" }),
            !n && m && /* @__PURE__ */ a(g, { size: r, icon: m }),
            c
          ]
        }
      ),
      content: t ? "" : e.label
    }
  );
};
export {
  k as Button
};
//# sourceMappingURL=index.js.map
